function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import classnames from "classnames";
import DefaultProps from "./default-props";
import { StyledTwoLinkButtonsButton } from "./two-link-buttons-button.scss";
class TwoLinkButtonsButton extends PureComponent {
    render() {
        const { secondaryButtonConfig, regularButtonConfig, swapButtonsOrder } = this.props;
        return /*#__PURE__*/ _jsxs(StyledTwoLinkButtonsButton, {
            className: classnames("two-link-buttons-button", {
                "swap-buttons-order": swapButtonsOrder
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "secondary-button-wrapper",
                    children: /*#__PURE__*/ _jsx(SecondaryButton, _object_spread({}, secondaryButtonConfig))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "regular-button-wrapper",
                    children: /*#__PURE__*/ _jsx(RegularButton, _object_spread({}, regularButtonConfig))
                })
            ]
        });
    }
}
export { TwoLinkButtonsButton as default };
TwoLinkButtonsButton.defaultProps = DefaultProps;
